module.exports = __webpack_public_path__ + "img/ZL02.0bb9fa42.png";